import React, { Component } from "react";
import { connect } from "react-redux";
import { userActions } from "../../_actions";
import InputBox from "./InputBox";

class LoginCode extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      code: "",
      showLogin: true,
      failureMSG: "",
      saveSuccess: false,
    };
  }

  /* ---------------- OTP CHANGE ---------------- */
  inputChangeOTP = (e) => {
    this.setState({ code: e.target.value, failureMSG: "" });
  };

  /* ---------------- VERIFY OTP ---------------- */
  OTPSubmit = () => {
    let { code } = this.state;

    let failureMSG = "";
    let formIsValid = true;

    let data = {
      code: code,
    };
    //code
    if (this.state.code === "") {
      formIsValid = false;
      failureMSG = "Please enter your OTP";
    } else {
      this.setState({ failureMSG: "" });
      this.setState({ saveSuccess: true });

      this.props.dispatch(userActions.userInsightCodeLogin(data, this.props));

    }
    this.setState({ failureMSG: failureMSG });

    setTimeout(() => {
      this.setState({ saveSuccess: false });
    }, 4000);
  };



  /* ---------------- CHANGE EMAIL ---------------- */
  changeEmail = () => {
    this.setState({
      email: "",
      code: "",
      showLogin: true,
      failureMSG: "",
    });
  };

  /* ---------------- ENTER KEY ---------------- */
  _handleKeyDown = (e) => {
    if (e.key === "Enter") {
      this.OTPSubmit();
    }
  };

  render() {
    const { code, failureMSG } = this.state;
    const { user } = this.props;

    const {
      userEmployeeValidateOtpSuccess,
      userEmployeeValidateOtpFailure,
    } = user;

    return (
      <>
        <div className="bg-white flex justify-center items-center h-screen">
          {/* LEFT IMAGE */}
          <div className="w-1/2 h-screen hidden lg:block">
            <img
              src="/img/insightplus-login.webp"
              alt="Login"
              className="object-cover w-full h-full"
            />
          </div>

          {/* RIGHT SECTION */}
          <div className="flex w-full md:w-1/2 items-center justify-center px-6 md:px-16 py-12">
            <div className="w-full max-w-lg flex-1">
              <div className="mb-10">
                {/*<img
                  src="/img/TalentPlusStrengths_logo.svg"
                  alt="TalentPlusStrengths"
                  className="h-14"
                />*/}
              </div>


              {/* OTP SCREEN */}
              <h1 className="text-4xl font-bold text-gray-900 mb-10">Welcome back!</h1>
              <h1 className="text-3xl font-semibold text-gray-900 mb-2">Sign in</h1>
              <p className="text-gray-500 text-sm mb-10">Enter your verification code.</p>

              <InputBox
                label="Enter CODE"
                name="otp"
                type="text"
                placeholder="Enter CODE"
                value={code}
                onChange={this.inputChangeOTP}
                onKeyDown={this._handleKeyDown}
              />

              {failureMSG && (
                <p className="text-red-500 text-sm mt-2">{failureMSG}</p>
              )}

              {userEmployeeValidateOtpFailure && (
                <p className="text-red-500 text-sm mt-2">
                  Invalid CODE
                </p>
              )}

              {userEmployeeValidateOtpSuccess && (
                <p className="text-green-600 text-sm mt-2">
                  CODE verified successfully!
                </p>
              )}

              <button
                onClick={this.OTPSubmit}
                className="w-full mt-6 bg-indigo-600 text-white font-medium py-3 rounded-md"
              >
                Submit Code
              </button>

            </div>

            <div className="absolute bottom-4 right-6">
              <p className="text-xs text-gray-500">
                All Rights Reserved | © InsightPlus 2026.
              </p>
            </div>
          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state;
  return { user };
}

export default connect(mapStateToProps)(LoginCode);